<template>
  <LcBadge :class="`discount discount-${size} bg-brand-yellow-yellow`">
    {{ $t('highfrequencygame.quantityselector.discount', { discount }) }}
  </LcBadge>
</template>

<script lang="ts" setup>
type Props = { discount: number; size?: 'medium' | 'small' }
const { size = 'medium' } = defineProps<Props>()
</script>

<style lang="scss" scoped>
.discount {
  min-height: unset;

  &-medium {
    height: token('size/space/gap/300');
  }

  &-small {
    height: 1.25rem;
  }
}
</style>
